export const c2f = (c: number): string => {
  const f = (c * 9) / 5 + 32
  return f.toFixed(1)
}
